import {atom, useAtomValue, getDefaultStore} from 'jotai';

type SyncStatus = 'idle' | 'syncing' | 'success';

const syncStatusAtom = atom<SyncStatus>('idle');

export const setSyncStatus = (status: SyncStatus) =>
  getDefaultStore().set(syncStatusAtom, status);

export const useSyncStatus = () => useAtomValue(syncStatusAtom);
